/**
 * Landing Page Combo 2 Pares - Modern E-Commerce UI/UX Bundle Logic
 * Includes dynamic color-to-image switching, smooth fade animation,
 * and 4-column compact size grid logic.
 */

document.addEventListener('DOMContentLoaded', () => {
  const comboBuilder = document.getElementById('arma-tu-combo');
  if (!comboBuilder) return;

  // Global selections for Par 1 and Par 2
  const selection = {
    step1: { variantId: null, title: '', size: '', color: '', img: '' },
    step2: { variantId: null, title: '', size: '', color: '', img: '' }
  };

  const addBtn = document.getElementById('btn-add-combo');
  const summarySlot1 = document.getElementById('summary-par-1');
  const summarySlot2 = document.getElementById('summary-par-2');

  function updateSummary() {
    if (summarySlot1) {
      if (selection.step1.variantId) {
        summarySlot1.innerHTML = `
          <img src="${selection.step1.img}" class="lp-summary-item__thumb" alt="${selection.step1.title}">
          <div class="lp-summary-item__info">
            <span class="lp-summary-item__label">Par 1: ${selection.step1.title}</span>
            <span class="lp-summary-item__variant">${selection.step1.color ? selection.step1.color + ' / ' : ''}Talla ${selection.step1.size}</span>
          </div>
        `;
      } else {
        summarySlot1.innerHTML = `
          <div class="lp-summary-item__placeholder">1</div>
          <div class="lp-summary-item__info">
            <span class="lp-summary-item__label">Par 1</span>
            <span class="lp-summary-item__variant">Elige modelo y talla arriba</span>
          </div>
        `;
      }
    }

    if (summarySlot2) {
      if (selection.step2.variantId) {
        summarySlot2.innerHTML = `
          <img src="${selection.step2.img}" class="lp-summary-item__thumb" alt="${selection.step2.title}">
          <div class="lp-summary-item__info">
            <span class="lp-summary-item__label">Par 2: ${selection.step2.title}</span>
            <span class="lp-summary-item__variant">${selection.step2.color ? selection.step2.color + ' / ' : ''}Talla ${selection.step2.size}</span>
          </div>
        `;
      } else {
        summarySlot2.innerHTML = `
          <div class="lp-summary-item__placeholder">2</div>
          <div class="lp-summary-item__info">
            <span class="lp-summary-item__label">Par 2</span>
            <span class="lp-summary-item__variant">Elige modelo y talla arriba</span>
          </div>
        `;
      }
    }

    if (addBtn) {
      const isComplete = selection.step1.variantId && selection.step2.variantId;
      addBtn.disabled = !isComplete;
      const textEl = addBtn.querySelector('.lp-btn-text') || addBtn;
      if (isComplete) {
        textEl.textContent = addBtn.dataset.textComplete || 'PEDIR CONTRA ENTREGA (PAGAR AL RECIBIR)';
      } else if (!selection.step1.variantId) {
        textEl.textContent = '1. ELIGE TU PRIMER PAR';
      } else {
        textEl.textContent = '2. ELIGE TU SEGUNDO PAR';
      }
    }
  }

  // Initialize every product card
  comboBuilder.querySelectorAll('.lp-product-card').forEach(card => {
    const rawJsonEl = card.querySelector('.lp-product-raw-json');
    if (!rawJsonEl) return;

    let productData;
    try {
      productData = JSON.parse(rawJsonEl.textContent);
    } catch (e) {
      console.error('Error parsing product JSON:', e);
      return;
    }

    const variants = productData.variants || [];

    // Parse color-to-image map
    let colorImageMap = {};
    const colorImagesEl = card.querySelector('.lp-variant-color-images');
    if (colorImagesEl) {
      try {
        colorImageMap = JSON.parse(colorImagesEl.textContent);
      } catch (e) {
        console.error('Error parsing color image map:', e);
      }
    }

    // Determine color and size option indexes
    let colorIndex = parseInt(card.dataset.colorIndex, 10);
    let sizeIndex = parseInt(card.dataset.sizeIndex, 10);

    if (isNaN(colorIndex)) {
      colorIndex = (productData.options || []).findIndex(opt => {
        const name = (typeof opt === 'string' ? opt : opt.name || '').toLowerCase();
        return name.includes('color');
      });
    }

    if (isNaN(sizeIndex)) {
      sizeIndex = (productData.options || []).findIndex(opt => {
        const name = (typeof opt === 'string' ? opt : opt.name || '').toLowerCase();
        return name.includes('talla') || name.includes('size');
      });
    }

    let activeColor = card.dataset.selectedColor || '';
    let activeSize = '';
    const imgEl = card.querySelector('.lp-product-card__img');
    const colorTextEl = card.querySelector('.lp-active-color-text');
    const sizeTextEl = card.querySelector('.lp-active-size-text');

    // Helper: switch image with instant browser reload and smooth crossfade
    function switchImage(newSrc) {
      if (!imgEl || !newSrc) return;
      if (newSrc.startsWith('//')) {
        newSrc = window.location.protocol + newSrc;
      }
      card.dataset.img = newSrc;

      imgEl.classList.add('is-fade');
      imgEl.removeAttribute('srcset');
      imgEl.removeAttribute('loading');
      imgEl.src = newSrc;

      const onDone = () => {
        imgEl.classList.remove('is-fade');
        imgEl.removeEventListener('load', onDone);
        imgEl.removeEventListener('error', onDone);
      };

      if (imgEl.complete) {
        setTimeout(onDone, 30);
      } else {
        imgEl.addEventListener('load', onDone);
        imgEl.addEventListener('error', onDone);
        setTimeout(onDone, 250); // Safety fallback
      }
    }

    // Helper: find variant for color & size
    function findVariant(col, sz) {
      return variants.find(v => {
        let matchCol = true;
        let matchSz = true;

        if (colorIndex !== -1 && col) {
          const vCol = (colorIndex === 0 ? v.option1 : colorIndex === 1 ? v.option2 : v.option3) || '';
          matchCol = (vCol.trim().toLowerCase() === col.trim().toLowerCase());
        }

        if (sizeIndex !== -1 && sz) {
          const vSz = (sizeIndex === 0 ? v.option1 : sizeIndex === 1 ? v.option2 : v.option3) || '';
          matchSz = (vSz.trim().toLowerCase() === sz.trim().toLowerCase());
        }

        return matchCol && matchSz;
      });
    }

    // Helper: update size buttons availability based on active color
    function updateSizeAvailability() {
      card.querySelectorAll('.lp-size-box-btn').forEach(btn => {
        const sz = btn.dataset.size;
        const matchingVar = findVariant(activeColor, sz);
        if (matchingVar && matchingVar.available) {
          btn.classList.remove('is-disabled');
        } else {
          btn.classList.add('is-disabled');
        }
      });
    }

    // Handle Color Chip Click
    card.querySelectorAll('.lp-color-chip').forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        card.querySelectorAll('.lp-color-chip').forEach(c => c.classList.remove('is-selected'));
        chip.classList.add('is-selected');

        activeColor = (chip.dataset.color || '').trim();
        card.dataset.selectedColor = activeColor;
        if (colorTextEl) colorTextEl.textContent = activeColor;

        const cleanActive = activeColor.toLowerCase();
        let newImgSrc = null;

        // 1. Direct Liquid image map lookup (case-insensitive & trimmed)
        for (const [colKey, url] of Object.entries(colorImageMap)) {
          if (colKey.trim().toLowerCase() === cleanActive && url) {
            newImgSrc = url;
            break;
          }
        }

        // 2. Fallback: check variants array
        if (!newImgSrc) {
          const matchedVar = variants.find(v => {
            if (colorIndex === -1) return false;
            const vCol = (colorIndex === 0 ? v.option1 : colorIndex === 1 ? v.option2 : v.option3) || '';
            const hasImg = v.featured_image || v.image;
            return vCol.trim().toLowerCase() === cleanActive && hasImg;
          });
          if (matchedVar) {
            const imgObj = matchedVar.featured_image || matchedVar.image;
            if (typeof imgObj === 'string') newImgSrc = imgObj;
            else if (imgObj && imgObj.src) newImgSrc = imgObj.src;
          }
        }

        // Apply image change to card IMMEDIATELY
        if (newImgSrc) {
          switchImage(newImgSrc);
        }

        updateSizeAvailability();

        // If this card is already selected or has active size, re-sync selection immediately
        if (card.classList.contains('is-selected') && activeSize) {
          const currentVar = findVariant(activeColor, activeSize);
          if (currentVar && currentVar.available) {
            applySelection(currentVar.id, activeSize, activeColor);
          } else {
            activeSize = '';
            if (sizeTextEl) sizeTextEl.textContent = 'Elige tu número';
            card.querySelectorAll('.lp-size-box-btn').forEach(b => b.classList.remove('is-selected'));
            removeSelection();
          }
        }
      });
    });

    // Initial size availability check
    updateSizeAvailability();

    // Handle Size Button Click
    card.querySelectorAll('.lp-size-box-btn').forEach(sizeBtn => {
      sizeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (sizeBtn.classList.contains('is-disabled')) return;

        const sz = sizeBtn.dataset.size;
        let variantId = sizeBtn.dataset.variantId;

        if (!variantId) {
          const matchedVar = findVariant(activeColor, sz);
          if (matchedVar) variantId = matchedVar.id;
        }

        if (!variantId) return;

        activeSize = sz;
        if (sizeTextEl) sizeTextEl.textContent = activeSize;

        // Deselect other cards & buttons in this step
        const step = card.dataset.step;
        const stepContainer = comboBuilder.querySelector(`[data-step="${step}"]`);
        if (stepContainer) {
          stepContainer.querySelectorAll('.lp-product-card').forEach(c => {
            if (c !== card) {
              c.classList.remove('is-selected');
              const sText = c.querySelector('.lp-active-size-text');
              if (sText) sText.textContent = 'Elige una';
              c.querySelectorAll('.lp-size-box-btn').forEach(b => b.classList.remove('is-selected'));
            }
          });
          card.querySelectorAll('.lp-size-box-btn').forEach(b => b.classList.remove('is-selected'));
        }

        card.classList.add('is-selected');
        sizeBtn.classList.add('is-selected');

        applySelection(variantId, activeSize, activeColor);
      });
    });

    function applySelection(variantId, sz, col) {
      const step = card.dataset.step;
      const title = card.dataset.title;
      const img = card.dataset.img || (imgEl ? imgEl.src : '');

      if (step === '1') {
        selection.step1 = { variantId, title, size: sz, color: col, img };
      } else {
        selection.step2 = { variantId, title, size: sz, color: col, img };
      }

      if (selection.step1.variantId && selection.step2.variantId) {
        window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [
          { id: parseInt(selection.step1.variantId, 10), quantity: 1 },
          { id: parseInt(selection.step2.variantId, 10), quantity: 1 }
        ];
      }

      updateSummary();
    }

    function removeSelection() {
      const step = card.dataset.step;
      card.classList.remove('is-selected');
      if (step === '1') {
        selection.step1 = { variantId: null, title: '', size: '', color: '', img: '' };
      } else {
        selection.step2 = { variantId: null, title: '', size: '', color: '', img: '' };
      }
      updateSummary();
    }
  });

  // Edit button scroll
  document.querySelectorAll('[data-action="edit-par-1"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const step1 = comboBuilder.querySelector('[data-step="1"]');
      if (step1) step1.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Releasit Cash on Delivery (COD) Direct Checkout Trigger
  async function triggerReleasitCOD() {
    if (!selection.step1.variantId || !selection.step2.variantId) {
      if (!selection.step1.variantId) {
        const step1 = comboBuilder.querySelector('[data-step="1"]');
        if (step1) step1.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        const step2 = comboBuilder.querySelector('[data-step="2"]');
        if (step2) step2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    const textEl = addBtn ? (addBtn.querySelector('.lp-btn-text') || addBtn) : null;
    const originalText = textEl ? textEl.textContent : '';
    if (addBtn) {
      addBtn.disabled = true;
      if (textEl) textEl.textContent = 'ABRIENDO PAGO CONTRA ENTREGA...';
    }

    const bundleId = 'combo_' + Date.now();

    // 1. Prepare items for cart with combo attributes
    const payload = {
      items: [
        {
          id: parseInt(selection.step1.variantId, 10),
          quantity: 1,
          properties: {
            '_bundle_group': bundleId,
            'Promoción': 'Combo 2 Pares',
            'Par 1': selection.step1.title + (selection.step1.color ? ' (' + selection.step1.color + ')' : '') + ' - Talla ' + selection.step1.size
          }
        },
        {
          id: parseInt(selection.step2.variantId, 10),
          quantity: 1,
          properties: {
            '_bundle_group': bundleId,
            'Promoción': 'Combo 2 Pares',
            'Par 2': selection.step2.title + (selection.step2.color ? ' (' + selection.step2.color + ')' : '') + ' - Talla ' + selection.step2.size
          }
        }
      ]
    };

    // 2. Set Releasit global items overwrite
    window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [
      { id: parseInt(selection.step1.variantId, 10), quantity: 1 },
      { id: parseInt(selection.step2.variantId, 10), quantity: 1 }
    ];

    try {
      // Clear old cart and add bundle items
      await fetch('/cart/clear.js', { method: 'POST' });
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!addRes.ok) {
        const err = await addRes.json();
        throw new Error(err.description || 'Error al agregar al carrito');
      }

      // 3. Open Releasit COD Form directly
      let opened = false;

      // Method A: Official Releasit JS Engine form.open in normalCart mode
      if (window._rsi && window._rsi.form && typeof window._rsi.form.open === 'function') {
        window._rsi.form.mode = 'normalCart';
        window._rsi.form.open();
        opened = true;
      }

      // Method B: Click Releasit generated buy button if present
      if (!opened) {
        const rsiBtn = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
        if (rsiBtn) {
          rsiBtn.click();
          opened = true;
        }
      }

      // Method C: Delayed check (if Releasit script was deferred or loading)
      if (!opened) {
        setTimeout(() => {
          if (window._rsi && window._rsi.form && typeof window._rsi.form.open === 'function') {
            window._rsi.form.mode = 'normalCart';
            window._rsi.form.open();
          } else {
            const btn = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
            if (btn) {
              btn.click();
            } else {
              window.location.href = '/checkout';
            }
          }
        }, 350);
      }
    } catch (err) {
      console.error('Error in COD process:', err);
      window.location.href = '/checkout';
    } finally {
      setTimeout(() => {
        if (addBtn) {
          addBtn.disabled = false;
          if (textEl) textEl.textContent = addBtn.dataset.textComplete || 'PEDIR CONTRA ENTREGA (PAGAR AL RECIBIR)';
        }
      }, 1200);
    }
  }

  // Bind Main CTA Button
  if (addBtn) {
    addBtn.addEventListener('click', (e) => {
      e.preventDefault();
      triggerReleasitCOD();
    });
  }

  // Bind Sticky Bar Button
  const stickyBtn = document.querySelector('.lp-sticky-bar__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      const isComplete = selection.step1.variantId && selection.step2.variantId;
      if (isComplete) {
        e.preventDefault();
        triggerReleasitCOD();
      } else {
        e.preventDefault();
        comboBuilder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // Smooth scroll links
  document.querySelectorAll('a[href="#arma-tu-combo"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault();
      comboBuilder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Sticky Bar Scroll Listener
  const stickyBar = document.querySelector('.lp-sticky-bar');
  if (stickyBar) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    });
  }
});
